import bugsnag from 'bugsnag-js'
const bugsnagClient = bugsnag({apiKey: process.env.VUE_APP_BUG_SNAG, appVersion: '1.0.0'})

export default bugsnagClient



// WEBPACK FOOTER //
// ./src/bugsnag.js